import { render, staticRenderFns } from "./CoachingHome.vue?vue&type=template&id=f9cdc502"
import script from "./CoachingHome.vue?vue&type=script&lang=js"
export * from "./CoachingHome.vue?vue&type=script&lang=js"
import style0 from "./CoachingHome.vue?vue&type=style&index=0&id=f9cdc502&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports